<div class="container card positionCard">
  <div class="row">
      <!--  <div class="col-md-6 col-sm-10 center-block text-center">
              <div class="page-head">We need your sign-off </div>
          </div> -->
  </div>
  <div class="row">
      <div class="col-md-6 col-sm-10 col-md-push-3 tablet-block">

          <div class="clearfix no-gutter-sm content-block head-padding">
              <div class="row">
                  <div class="col-xs-12 text-center">
                      <div class="subhead-header">OTP Verification</div>
                  </div>
              </div>
              <div class="row center-block">
                  <div class="content-holder col-xs-12 col-sm-12">
                    <div class="col-xs-12 col-sm-12 esign-heading-OTP">OTP has been sent to&nbsp;<span class="esign-otp-mobile">{{mobileNo}}</span></div>
                  </div>
                  <div class="col-xs-12 col-sm-12 ">
                      <div [formGroup]="OtpForm" class="top-40 left-70 otp-esign-mob-disp">
                          <div class="form-group col-sm-12 col-xs-12 margin-none no-gutter-sm no-gutter-xs col-md-9">
                              <div class="input-group" [ngClass]="OtpErrorMsg ? 'text-danger' : ''">
                                  <input  type="tel" required class="form-control text-capitalize formControl" 
                                   id="field_Otp" formControlName="otp" name="otp" autocomplete="off" placeholder="Enter OTP" maxlength="6" pattern="^\d{6}$">
                              </div>
                              <div *ngIf="OtpErrorMsg" class="text-danger text-left">
                                      <span class="icon-info"></span> {{OtpErrorMsg}}
                              </div>
                          </div>
                          <div [clickDelay]=5000 class="col-md-3 top-20 esign-mob-resend" (click)="onSendOtp()" [ngClass]="(resendOtpExceedFlag)?'cursor-not-allowed':''">
                              <span class="esign-resend-otp" *ngIf="!resendOtpExceedFlag">Resend OTP</span>
                          </div>
                      </div>
                  </div><!-- 
                    <div class="col-md-12 col-xs-12">
                            <div class="esign-note-text">Note : Your OTP is only valid till 1:00.</div>
                    </div> -->
                      <div class="row text-center">
                          <div class="col-md-12 top-50 esign-mob-complete">
                                  <button type="button" class="btn btn-orange" (click)="SubmitOtpForm(OtpForm.value)"
                                   id="esignComplete" [disabled]="ShowLoader || !OtpForm.valid">COMPLETE eSIGN
                                  <img class="btn-loader" *ngIf="ShowLoader" src="assets/img/loader_orange.gif" />
                                 </button>
                          </div>
                      </div>
              </div>
          </div>
      </div>
  </div>
</div>
